import React, { useEffect, useState } from "react";
import { Constants } from "../libs/Constants";
import { create } from "../libs/dbFunctions";

const ViewFileURL = ({ fileName }) => {
    const [url, setUrl] = useState(null);

    useEffect(() => {
        onLoad();
    }, [fileName]);
    const onLoad = async () => {
        try {
            let response = await create(Constants.dbTypes.FILE, {
                fileAction: 'getObject',
                fileURL: fileName
            });
            if (response && response.url)
                setUrl(response.url);
        } catch (e) {
            console.log(e);
        }
    }
    return (
        <a
            className="text-primary"
            href={url}
            target="_blank"
        >
            View
        </a>
    );
};

export default ViewFileURL;
